<template>
  <div>
    <div v-if="!!propObito.registro.transporte"
         class="col-12">
      <div class="row mt-2 mb-2 transporte">
        Existe Transporte - {{ 'Livro ' + propObito.registro.transporte.livro + ', fls. ' + propObito.registro.transporte.folha + '-' + propObito.registro.transporte.lado.toLowerCase() }}
      </div>
    </div>
    <div class="mt-3 pl-3 pr-3">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-8">
          <div class="row">
            <div class="col-2 col-sm-3">
              <label class="resumo-show_label"
                     for="">CPF</label>
              <div class="resumo-show_sublabel">
                {{ pessoa.cpf || 'Não informado' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for="">Nome</label>
              <div class="resumo-show_sublabel">
                {{ pessoa && pessoa.nome || 'Não informado' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for="">Sexo</label>
              <div class="resumo-show_sublabel">
                {{ sexo[pessoa.sexo] || 'Não informado' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="row">
            <div class="col-6 px-1">
              <Carga :prop-registro="registro"
                     :prop-obito-id="obitoId"
                     prop-tipo-registro="O"
                     :prop-data-carga="data_carga"
                     @reload="reload" />
            </div>
            <div class="col-6 px-1">
              <ExportarXML :prop-registro-id="registro.registro_id" />
            </div>
            <div id="transporte-obito"
                 class="col-6 px-1 mt-2">
              <button
                class="btn btn-outline-primary btn-block btn-sm"
                :disabled="!!propObito.registro.transporte"
                @click="gerarTransporte">
                Transporte
              </button>
            </div>
            <b-tooltip v-if="!!propObito.registro.transporte"
                       target="transporte-obito">
              Este registro já foi transportado.
            </b-tooltip>
            <div class="col-6 px-1 pt-2">
              <button
                class="btn btn-secondary btn-block btn-sm btn-editar-obito-primary"
                @click="editarObito">
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div role="tablist">
      <genitores-collapse v-if="pessoa"
                          :genitores="pessoa.genitores"
                          :collapse-visible="false"
                          :prop-nascimento="false" />

      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickEndereco, 'clickEndereco')">
        <button v-b-toggle.endereco
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickEndereco, 'clickEndereco')">
          Endereço {{ !pessoa.endereco ? ' - Nenhum informado' : '' }}
          <span v-if="pessoa.endereco">
            <span v-if="!clickEndereco">
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowRight" />
            </span>
            <span v-else>
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowDown" />
            </span>
          </span>
        </button>

        <b-collapse v-if="clickEndereco"
                    id="endereco"
                    :key="`endereco_${pessoa.endereco.endereco_id}`"
                    class="mt-3 pb-2 resumo-show_header--shadow">
          <div class="resumo-show_header--blue">
            {{ pessoa.endereco.logradouro || 'Não informado' }}
          </div>
          <div class="pl-4 pl-4 row">
            <div class="col-10">
              <div class="row">
                <div class="col">
                  <label class="resumo-show_header--label">CEP</label>
                  <div class="resumo-show_header--sublabel">
                    {{ pessoa.endereco.cep || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Número</label>
                  <div class="resumo-show_header--sublabel">
                    {{ pessoa.endereco.numero || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Complemento</label>
                  <div class="resumo-show_header--sublabel">
                    {{ pessoa.endereco.complemento || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Bairro</label>
                  <div class="resumo-show_header--sublabel">
                    {{ pessoa.endereco.bairro || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Cidade</label>
                  <div class="resumo-show_header--sublabel">
                    {{ pessoa.endereco.cidade || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">UF</label>
                  <div class="resumo-show_header--sublabel">
                    {{ pessoa.endereco.uf || 'Não informado' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickRegistroAnterior, 'clickRegistroAnterior')">
        <button v-b-toggle.registros_anteriores
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickRegistroAnterior, 'clickRegistroAnterior')">
          Vinculação de Registros Anteriores {{ !registro.anteriores.length ? ' - Nenhum informado' : '' }}
          <span v-if="!!registro.anteriores.length">
            <span v-if="!clickRegistroAnterior">
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowRight" />
            </span>
            <span v-else>
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowDown" />
            </span>
          </span>
        </button>

        <b-collapse v-if="clickRegistroAnterior"
                    id="registros_anteriores">
          <registros-anteriores-resultados v-if="registro.anteriores.length > 0"
                                           :prop-radio="false"
                                           :prop-vinculado="true"
                                           :prop-just-show="true"
                                           :prop-resultados="registro.anteriores" />
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
  /* assets */
  import icon_engagement from "@/assets/icons/engagement.svg?sprite"

  /* components */
  import RegistrosAnterioresResultados from "@/components/SofiaRei/RegistrosAnteriores/RegistrosAnterioresResultados"
  import IconSvg  from "@/components/IconSvg"
  import Carga from '../../Carga/Carga'
  import GenitoresCollapse from "@/components/SofiaRei/Resumo/Collapses/GenitoresCollapse"
  import ExportarXML  from "@/components/ExportarXML"

  // outros

  /* services */
  import ObitoService from "@/services/Registros/Obito"

  /* others */
  import moment from 'moment'
  import {mapGetters} from "vuex"

  export default {
    name: "First",
    components: {
      RegistrosAnterioresResultados,
      IconSvg,
      Carga,
      GenitoresCollapse,
      ExportarXML
    },
    props: {
      pessoa: { type: Object, default: () => {} },
      obitoId: { type: [Number, String], default: () => "" },
      registro: { type: Object, default: () => {} },
      propObito: { type: Object, default: () => ({}) }
    },
    data () {
      return {
        icon_engagement,
        estado_civil: {
          'SEPARADO_JUDICIALMENTE': 'Separado Judicialmente',
          'SOLTEIRO': 'Solteiro',
          'CASADO': 'Casado',
          'VIUVO': 'Viúvo',
          'DIVORCIADO': 'Divorciado',
        },
        sexo: {
          'I': 'Indefinido',
          'M': 'Masculino',
          'F': 'Feminino'
        },
        carga: false,
        data_carga: null,
        certificados: [],
        assinadorCarga: null,
        clickGenitores: false,
        clickEndereco: false,
        clickRegistroAnterior: false,
        nodeEnv: process.env.NODE_ENV
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    watch: {
      registro () {
        this.getDataCarga()
      }
    },
    mounted () {
      this.getDataCarga()
    },
    methods: {
      cardChanged (val, name) {
        this[name] = !val
      },
      editarObito () {
        this.$emit('onGoEditarObito')
      },
      getDataCarga () {
        if (!this.registro.data_carga) {
          this.data_carga = null
          return
        }

        const data = moment(this.registro.data_carga).format('DD/MM/YYYY')
        const hora = moment(this.registro.data_carga).format('H:mm').replace(':', 'h')

        this.data_carga = `Enviada ${data} ${hora}`
      },
      async reload () {
        try {
          loader({ text: "Carregando dados...", active: false })

          const obito = await ObitoService.getObitoById(this.$route.params.id, this.$store.state.auth.cartorio_id, this.registro.registro_id)

          this.$emit('updateObito', obito)

          this.registro.data_carga = obito.registro.data_carga
          this.getDataCarga()
        } catch (error) {
          console.error(error)
        } finally {
          loader({ text: "", active: false })
        }
      },
      async gerarTransporte () {
        const res = await displayMessage('question', 'Deseja realizar o transporte deste registro?')

        if (res.value) {
          try {
            loader({ text: "Gerando transporte...", active: false })

            const registro = this.propObito.registro

            await ObitoService.transporte(registro)

            displayMessage('success','Transporte realizado com Sucesso!').then(() => {
              this.reloadObito()
            })
          } catch (error) {
            console.error(error)
          } finally {
            loader({ text: "", active: false })
          } 
        } 
      },
      reloadObito () {
        this.$emit('reloadObito', true)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-editar-obito-primary {
    fill:white
  }

  .cardInfo {
    padding-top: 15px;
    border-radius: 0;
    border: 0 solid;
  }

  .cardInfoBtn {
    border-radius: 0;
    border: 0 solid;
    background-color: #eaeaea;
    color: #000;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    padding: 10px;
    padding-left: 19px;
    margin-bottom: 1px;
  }

  .cardInfoBtn:active,
  .cardInfoBtn:hover {
    outline: 0 !important;
  }

  .data-carga{
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    color: #373a3c;
    margin: 0;
  }

  .transporte {
      background: #00bdc5 ;
      color: #FFFFFF;
      padding: 2px;
      padding-left: 10px;
  }
</style>
